import { render } from "./BaseLabel.vue?vue&type=template&id=7b29f1a6"
import script from "./BaseLabel.vue?vue&type=script&lang=ts"
export * from "./BaseLabel.vue?vue&type=script&lang=ts"
script.render = render

export default script